export const ProjectsArray = [
  {
    id: 1,
    name: "XoloBooks",
    description:
      "This project was built and currently mantained using WIX eCommerce. It is an online-store integration using wix-databases, custom JavaScript and much more.",
    url: "https://www.xolobooks.com/",
    git: 0,
    images: [
      "https://news-api.s3.us-east-2.amazonaws.com/XoloBooks.png",
      "https://news-api.s3.us-east-2.amazonaws.com/XoloBooks_Bookstore.png",
      "https://news-api.s3.us-east-2.amazonaws.com/XoloBooks_SignUp.png",
      "https://news-api.s3.us-east-2.amazonaws.com/XoloBooks_Why_Used.png",
    ],
  },
  {
    id: 5,
    name: "NPMly",
    description:
      "This project was built using React.js, Bootstrap and Javascript. NPMly can help you quickly add and generate npm install, npm update or npm uninstall commands which require multiple packages.",
    url: "https://www.npmly.com/",
    git: 0,
    images: [],
  },
  {
    id: 6,
    name: "Redencion Cleaning",
    description:
      "Residential and commercial cleaning services and personnel. This project was build with WIX with wix-database integration and Javascript custom components.",
    url: "https://www.redencioncleaning.com/",
    git: 0,
    images: [
      "https://news-api.s3.us-east-2.amazonaws.com/SplashPageMock.png",
      "https://news-api.s3.us-east-2.amazonaws.com/SplashPageMock_Home.png",
      "https://news-api.s3.us-east-2.amazonaws.com/SplashPageMock_Projects.png",
    ],
  },
  {
    id: 9,
    name: "Authentication",
    description:
      "This project was built with ReactJS, TypescriptJS, MySQL, NodeJS with Express, and much more. It includes passport-jwt authentication, CRUD operations, 3rd party API calls, and much much more.",
    url: "https://github.com/PawelPavo/searchBar",
    git: 1,
    images: [
      "https://news-api.s3.us-east-2.amazonaws.com/CRUD_BLOG_Register.png",
      "https://news-api.s3.us-east-2.amazonaws.com/CRUD_BLOG_Login.png",
      "https://news-api.s3.us-east-2.amazonaws.com/CRUD_BLOG.png",
      "https://news-api.s3.us-east-2.amazonaws.com/CRUD_BLOG_View_Blog_2.png",
      "https://news-api.s3.us-east-2.amazonaws.com/CRUD_BLOG_Comment.png",
      "https://news-api.s3.us-east-2.amazonaws.com/CRUD_BLOG_Profile_Page.png",
    ],
  },
  {
    id: 7,
    name: "Single Scroll Mock",
    description:
      "This project was built as static SPA. It uses ReactJS, Typescript and Styled-Components with Bootstrap. It has a multi-language “Hello” carousel and stunning animation for transitional visual effects.",
    url: "https://github.com/PawelPavo/Portfolio-Infinite-Scroll",
    git: 1,
    images: [
      "https://news-api.s3.us-east-2.amazonaws.com/SingleScrollMock.png",
      "https://news-api.s3.us-east-2.amazonaws.com/SingleScrollMock_Bio.png",
      "https://news-api.s3.us-east-2.amazonaws.com/SingleScrollMock_Contact.png",
    ],
  },
  {
    id: 8,
    name: "First Portfolio",
    description:
      "This is my first portfolio websites built with ReactJS, Javascript, Bootstrap with Styled-Components and JSON static files. This portfolio is currently hosted on GitHub-Pages.",
    url: "https://pawelpavo.github.io/Pawel_Site_4/#/Pawel_Site_4/",
    git: 0,
    images: [
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_OFF.png",
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_ON.png",
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_OFF_Projects.png",
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_ON_Projects.png",
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_OFF_Contact.png",
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_ON_Contact.png",
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_OFF_Resume.png",
      "https://news-api.s3.us-east-2.amazonaws.com/Light_Dark_theme_1_Theme_ON_Resume.png",
    ],
  },
];
